import { render } from "./adminWrapper.vue?vue&type=template&id=ef3ab480"
import script from "./adminWrapper.vue?vue&type=script&lang=js"
export * from "./adminWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@5.111.1_postcss@8.5.29_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__